import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* istanbul ignore file */
import { useQuery } from '@tanstack/react-query';
import getFetchIdentityOptions from './get-options';

/**
 * useFetchIdentity provides React components with access to identity data.
 * If you need this data in a non-React context, use the webShellClient.identity functions directly.
 * The useQuery wrapper is necessary to use async code in React, but outside of React we can await the functions directly.
 */
var useFetchIdentity = function useFetchIdentity() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      enabled: true
    },
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    select = _ref.select;
  var queryOptions = getFetchIdentityOptions();
  return useQuery(_objectSpread(_objectSpread(_objectSpread({}, queryOptions), {}, {
    enabled: enabled
  }, select && {
    select: select
  }), {}, {
    placeholderData: {
      isSwooshUser: null,
      isLoggedIn: null,
      userType: '',
      visitorId: '',
      visitId: '',
      token: '',
      upmId: '',
      userInitialized: null
    }
  }));
};
export default useFetchIdentity;